/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ResetPasswordConfirm/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Credentials from './Credentials/index'
import React from 'react'
import TwoFactorAuth from './TwoFactorAuth/index'
import TysiaBrandLogo from 'DesignSystem/TysiaBrandLogo/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function ResetPasswordConfirm({
  children,
  viewPath = "/App/Auth/ResetPasswordConfirm"
  
}) {
  let isBefore = useIsBefore()
  let isMedia = useIsMedia()
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Credentials'
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsWhite1 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white;'
        })
let dtSpaceXl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xl'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="ResetPasswordConfirm.Vertical"
  data-view-path={viewPath}
 style={{'--bc-3-1qNAtJ': dtColorsWhite,'--o-1-1qNAtJ': isBefore ? 0 : 1,'--tx-2-1qNAtJ': isBefore ? "-32px" : "0px"}}
 className={`views-block ${styles.Vertical}`}
>
<fromFlow.When is={isMedia.desktop}>
<div
  data-testid="ResetPasswordConfirm.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-3-1qNAtJ': dtColorsWhite1,'--pt-4-1qNAtJ': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl,'--pr-5-1qNAtJ': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl,'--pb-6-1qNAtJ': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl,'--pl-7-1qNAtJ': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="ResetPasswordConfirm.Vertical:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical2}`}
/>
<TysiaBrandLogo
  viewPath={`${viewPath}/TysiaBrandLogo`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="The extensible, cloud-based orthodontic software with advanced scheduling, communication tools, automations, and seamless integrations"
 color={dtColorsWhite}
 fontSize="22px"
 lineHeight="32px"
/>
</div>
</fromFlow.When>
<div
  data-testid="ResetPasswordConfirm.Vertical:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical3}`}
>
<div
  data-testid="ResetPasswordConfirm.Vertical:4"
  data-view-path={viewPath}
 style={{'--w-8-1qNAtJ': isMedia.mobile ? "340px" : "400px"}}
 className={`views-block ${styles.Vertical4}`}
>
<div
  data-testid="ResetPasswordConfirm.Vertical:5"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h2"
 marginTop={dtSpaceS}
 marginBottom={dtSpaceXxs}
 text="Set new password"
/>
</div>
<fromFlow.When is={flowValue === 'Credentials'}>
<Credentials
  viewPath={`${viewPath}/Credentials`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'TwoFactorAuth'}>
<TwoFactorAuth
  viewPath={`${viewPath}/TwoFactorAuth`}
/>
</fromFlow.When>
</div>
</div>
</div>
{children}
</React.Fragment>)
}